const oldReplacement = {
    path: "/oldReplacement", //主体
    name: "oldReplacement",
    redirect: '/oldReplacementElder',
    component: () =>
        import ("../views/oldReplacement/main"),
  children: [
            {
                path: "/oldReplacementElder", //老人信息
                name: "oldReplacementElder",
                mate: {
                    title: '老人信息'
                },
                component: () =>
                    import ("../views/oldReplacement/elderInfo/index")
            },
            {
                path: "/oldReplacementServeInfo", //服务信息
                name: "oldReplacementServeInfo",
                mate: {
                    title: '服务信息'
                },
                component: () =>
                    import ("../views/oldReplacement/oldReplacementServeInfo/index")
            },
            {
                path: "/oldReplacementProduct", //产品信息
                name: "oldReplacementProduct",
                mate: {
                    title: '产品信息'
                },
                component: () =>
                    import ("../views/oldReplacement/oldReplacementProduct/index")
            },
        ]
}

export default oldReplacement